export default __webpack_public_path__ + "static/media/Assured-Income-Star.68db987a.pdf";